<!-- Components for datepicker tag    -->

<script>
import DatePicker from 'vue2-datepicker'

import { services } from '@src/utils/common-services'
export default {
  // Change the v-model event name to `update` to avoid changing
  // the behavior of the native `input` event.
  // https://vuejs.org/v2/guide/components-custom-events.html#Customizing-Component-v-model
  components: { DatePicker },
  // Disable automatic attribute inheritance, so that $attrs are
  // passed to the <input>, even if it's not the root element.
  // https://vuejs.org/v2/guide/components-props.html#Disabling-Attribute-Inheritance
  inheritAttrs: false,

  model: {
    event: 'update',
  },
  props: {
    validation: {
      type: Object,
      default() {
        return {}
      },
    },
    // eslint-disable-next-line vue/require-default-prop
    options: {
      type: Object,
      default() {
        return {}
      },
    },
    // eslint-disable-next-line vue/require-prop-types
    value: {
      type: String,
      default() {
        return null
      },
    },
    label: {
      type: String,
      default() {
        return ''
      },
    },
    form: {
      type: String,
      default() {
        return ''
      },
    },
    name: {
      type: String,
      default: 'name',
    },
    type: {
      type: String,
      default() {
        return 'date'
      },
    },
    // Only allow types that essentially just render text boxes.
  },
  data() {
    return {
      data: null,
    }
  },

  computed: {
    validationNotBefore() {
      return this.options.validationNotBefore !== undefined
        ? services.findDate(this.options.validationNotBefore)
        : services.findDate(-100)
    },
    validationNotAfter() {
      return this.options.validationNotAfter !== undefined
        ? services.findDate(this.options.validationNotAfter)
        : services.findDate(0)
    },
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal) this.data = this.value
    },
  },
  beforeMount() {
    if (this.value !== null) this.data = this.value
  },

  methods: {
    callDependency(data) {
      if (
        this.options.dependency !== undefined &&
        this.options.dependency !== null
      ) {
        if (data !== null) {
          var date2 = services.findDate(0)
          var parts = data.split('-')
          // Please pay attention to the month (parts[1]); JavaScript counts months from 0:
          // January - 0, February - 1, etc.
          var mydate = new Date(parts[1], parts[0] - 1)

          var diffDays = parseInt((date2 - mydate) / (1000 * 60 * 60 * 24), 10)

          if (diffDays / 365 < 10) {
            this.$root.$emit('dependency', { name: this.name, value: true })
          } else
            this.$root.$emit('dependency', { name: this.name, value: false })
        } else this.$root.$emit('dependency', { name: this.name, value: true })
      }
    },
    sendData(data) {
      // EventBus.$emit('testEvent', 'test')

      if (data === '') data = null

      this.$emit('update', data)
      this.callDependency(data)
    },
  },
}
</script>

<template>
  <div :class="$style.formGroup" class="formGroup mt20 mt10-sm">
    <div class="formFieldWrap">
      <label
        :for="name"
        :class="$style.fieldTitle"
        class="w40 w100-sm FL pr15 pr0-sm"
        >{{ label }}</label
      >
      <div class="form-field w60 w100-sm FL">
        <div :class="$style.inputField">
          <ValidationProvider
            v-slot="{ errors }"
            mode="passive"
            :vid="name"
            :name="name"
            :rules="validation"
          >
            <DatePicker
              :id="name"
              v-model="data"
              :not-before="validationNotBefore"
              :not-after="validationNotAfter"
              :name="name"
              :type="type"
              :placeholder="options.placeholder"
              value-type="format"
              lang="en"
              width="100%"
              :format="
                options.format !== undefined ? options.format : 'DD-MM-YYYY'
              "
              @change="sendData"
            ></DatePicker>
            <span v-show="errors[0]" :class="$style.error">{{
              errors[0]
            }}</span>
          </ValidationProvider>
        </div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>
<style lang="scss" module>
@import '@design';
.formGroup {
  max-width: 500px;
}
</style>
